import { __rest } from "tslib";
import React, { forwardRef } from "react";
import { generateKey } from "../../shared/utils";
import * as S from "./styles";
export var Checkbox = forwardRef(function (e, t) {
  var _e$bodyTextStyle = e.bodyTextStyle,
      a = _e$bodyTextStyle === void 0 ? !1 : _e$bodyTextStyle,
      r = e.border,
      c = e.checked,
      l = e.checkMarkColor,
      o = e.className,
      d = e.disabled,
      n = e.label,
      b = e.name,
      s = e.onChange,
      _e$uid = e.uid,
      m = _e$uid === void 0 ? generateKey() : _e$uid,
      i = __rest(e, ["bodyTextStyle", "border", "checked", "checkMarkColor", "className", "disabled", "label", "name", "onChange", "uid"]);

  return React.createElement(S.Wrapper, Object.assign({
    className: o,
    border: r,
    checked: c,
    disabled: d,
    onClick: d ? function () {} : s,
    "data-testid": "checkbox-" + m
  }, i), React.createElement(S.CheckboxContainer, null, React.createElement(S.HiddenCheckbox, Object.assign({}, e, {
    name: b,
    "aria-label": n,
    ref: t
  })), React.createElement(S.StyledCheckbox, {
    border: r,
    checked: c,
    disabled: d
  }, React.createElement(S.Checkmark, {
    "data-testid": "checkmark",
    color: l,
    disabled: d
  }))), React.createElement(S.Label, {
    disabled: d,
    htmlFor: b
  }, React.createElement(S.LabelContent, null, React.createElement(S.LabelText, {
    bodyTextStyle: a
  }, n))));
});
export default Checkbox;